import TablePage, { TableConfig } from '../../../components/table/TablePage';
import { apiPartnersGetInfo } from '../../../actions/partnesActions';

const configHeads = [
  {
    name: '',
    width: '20px',
    key: 'empty',
  },
  {
    name: 'Name',
    width: null,
    type: 'string',
    key: 'partner_name',
  },
  {
    name: '24h videos',
    width: null,
    type: 'string',
    key: 'elements_day',
  },
  {
    name: '2 days videos',
    width: null,
    type: 'string',
    key: 'elements_2_day',
  },
  {
    name: '3 days videos',
    width: null,
    type: 'string',
    key: 'elements_3_day',
  },
  {
    name: '7 days videos',
    width: null,
    type: 'string',
    key: 'elements_7_day',
  },
  {
    name: 'Last Uploaded Video',
    width: null,
    type: 'date',
    key: 'element_last_created_at',
    options: {
      format: 'DD/MM/YYYY HH:mm:ss',
    },
  },
  {
    name: 'Send Type',
    width: null,
    type: 'string',
    key: 'send_type',
  },
  {
    name: 'Receive Type',
    width: null,
    type: 'string',
    key: 'receive_type',
  },
];

const config: TableConfig = {
  title: 'Partners',
  key: 'partners',
  functions: {
    loadElementsMethod: apiPartnersGetInfo,
    convertElementsMethod: null,
  },
  options: {
    hasSearch: false,
    hasSwitcher: false,
  },
  filters: [],
  heads: configHeads,
};

function PanelPartners() {
  return (
    <>
      <TablePage config={config} />
    </>
  );
}

export default PanelPartners;
